const max = (2 ** 31 - 1) | 0;

export default max;
